import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import PlanAContainer from "Containers/PlanAContainer";
import chunk from "lodash/chunk";
import Button from "ComponentsUI/Button";
import { inject, observer } from "mobx-react";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import Carousel from "nuka-carousel";
import PlanALayout from "ComponentsUI/Tariffication/layouts/PlanALayout";
import { BottomPoints, StylesForButtons } from "ComponentsUI/CarouselComponents";

const styles = (theme) => ({
	item: {
		marginBottom: "20px",
	},
	buttonWrapper: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
	},
	button: {
		width: "380px",
	},
	ad: {},
	carousel: {},
	carouselItem: {},
	adblock: {},
	root: {
		marginBottom: "-20px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		button: {
			width: "460px",
		},
		ad: {
			marginTop: "20px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		button: {
			width: "350px",
		},
		ad: {
			marginTop: "20px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		carousel: {
			width: "calc(100% + 40px)",
			margin: "0 -20px 40px",
			"& .slider-decorator-0": {
				bottom: "-40px !important",
			},
			"& .slider-slide:last-child, .slider-slide:nth-last-child(2)": {
				bottom: " 0 !important",
			},
		},
		carouselItem: {
			margin: "0 20px",
			width: "auto",
		},
		item: {
			marginBottom: "16px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
		button: {
			width: "100%",
		},
		adblock: {
			margin: "0 -20px",
			width: "auto",
		},
	},
});

@inject("ApplicationModel")
@observer
class PlansList extends React.Component {
	static defaultProps = {
		planAdd: null,
		flat: false,
		onClick: () => {},
		onItemSelect: () => {},
		showLogo: true,
		showAdBlock: false,
		onClickViewAll: () => {},
		onClickPlanAddButton: () => {},
	};

	render() {
		let text = this.props.ApplicationModel.text;
		if (this.props.stub) {
			return (
				<div>
					<Row className="align-items-stretch">{this.renderStubItems()}</Row>
				</div>
			);
		}
		if (!this.props.items.length) {
			return (
				<Container>
					<Row>
						<Col
							lg={{ size: 4, offset: 4 }}
							md={{ size: 4, offset: 4 }}
							sm={{ size: 4, offset: 4 }}
							xs={{ size: 6, offset: 3 }}
						>
							<EmptyStub
								header={text.NO_TARIFFS_HEADER}
								text={text.NO_TARIFFS_TEXT}
								icon={
									<span
										className="icon48 icon-balance"
										style={{
											fontSize: "48px",
											color: "#5812fe",
										}}
									/>
								}
								button={
									<Button typeText={"small"} size={"low"} status={"withoutAccent"}>
										<span
											className="icon48 icon-playlist-add"
											style={{
												fontSize: "24px",
												color: "#d3cee1",
											}}
										/>
										{text.WRITE_REVIEW}
									</Button>
								}
							/>
						</Col>
					</Row>
				</Container>
			);
		}

		let classes = this.props.classes;

		return (
			<div className={classes.root}>
				<Row className="align-items-stretch">
					{this._renderItems()}
					{this.props.useCarousel && this.props.windowSizes.xs && this._renderCarousel()}
					{this.props.windowSizes.lg && this.props.planAdd && this._renderPlanAdd(false)}
					{this._renderViewAllButton()}
					{!this.props.windowSizes.lg && this.props.planAdd && this._renderPlanAdd(true)}
				</Row>
			</div>
		);
	}

	renderStubItems() {
		let classes = this.props.classes;
		let items = 4;
		let array = [];
		if (this.props.windowSizes.lg) {
			items = 6;
		}
		if (this.props.windowSizes.xs) {
			items = 2;
		}
		for (let i = 0; i < items; i++) {
			array.push(
				<Col xs="12" sm="3" lg="2" key={i} className={classes.item}>
					<PlanALayout stub={true} />
				</Col>
			);
		}
		return array;
	}

	componentDidMount() {
		setTimeout(() => this.recalculate(), 500);
	}

	recalculate() {
		this.carousel && this.carousel.setDimensions();
	}

	_renderCarousel() {
		let decorator = [
			{
				component: (props) => (
					<BottomPoints {...props} getButtonStyles={StylesForButtons.greyPoints} />
				),
				position: "BottomCenter",
			},
		];
		let classes = this.props.classes;
		let items = this.props.items.map((item, key) => (
			<div className={classes.carouselItem} key={key}>
				<PlanAContainer
					isMount={() => this.recalculate()}
					data={item}
					withoutButtons={this.props.withoutButtons}
					onClick={() => this.props.onClick(item)}
					showLogo={this.props.showLogo}
					disabled={this.props.disabled}
				/>
			</div>
		));
		if (!!items.length && !!this.props.planAdd) {
			items.push(
				<div className={classes.carouselItem} key={"planAdd"}>
					{this.props.planAdd}
				</div>
			);
		}

		if (!!items.length && !!this.props.adblock2) {
			items.push(
				<div className={classes.carouselItem} key={"free"}>
					{this.props.adblock2.element}
				</div>
			);
		}

		return (
			<div className={classes.carousel}>
				<Carousel
					ref={(carousel) => (this.carousel = carousel)}
					wrapAround={true}
					decorators={decorator}
					needRecalculateHeight={true}
					heightMode="max"
				>
					{items}
				</Carousel>
			</div>
		);
	}

	_renderItems() {
		if (!!this.props.useCarousel && this.props.windowSizes.xs) {
			return null;
		}
		let classes = this.props.classes;
		let sizeOfChunks = this.props.windowSizes.lg ? 6 : 4;
		let chunks = chunk(this.props.items, sizeOfChunks);
		let arrayOfTariffs = [];
		let adBlock2Isinserted = !this.props.adblock2;
		let adblock2 = this.props.adblock2;

		chunks.map((item, index) => {
			item.forEach((item, index) => {
				arrayOfTariffs.push(
					<Col xs="12" sm="3" lg="2" key={`${item.id}-${index}`} className={classes.item}>
						<PlanAContainer
							data={item}
							withoutButtons={this.props.withoutButtons}
							onClick={() => this.props.onClick(item)}
							showLogo={this.props.showLogo}
							disabled={this.props.disabled}
						/>
					</Col>
				);
				if (adblock2 && arrayOfTariffs.length == adblock2.position) {
					adBlock2Isinserted = true;
					arrayOfTariffs.push(
						<Col xs="12" sm="3" lg="4" key={"free"} className={classes.item}>
							{adblock2.element}
						</Col>
					);
				}
			});
		});

		if (!adBlock2Isinserted) {
			if (this.props.windowSizes.lg && arrayOfTariffs.length % 6 == 5) {
				arrayOfTariffs.splice(
					arrayOfTariffs.length - 1,
					0,
					<Col xs="12" sm="3" lg="4" key={"free"} className={classes.item}>
						{adblock2.element}
					</Col>
				);
			} else {
				arrayOfTariffs.push(
					<Col xs="12" sm="3" lg="4" key={"free"} className={classes.item}>
						{adblock2.element}
					</Col>
				);
			}
		}

		let insertAdBlock = 6;
		if (this.props.windowSizes.md || this.props.windowSizes.sm) insertAdBlock = 4;

		if (arrayOfTariffs.length > insertAdBlock) {
		}

		if (this.props.showAdBlock) {
			let adblock = (
				<div className={classes.adblock} key="adblock">
					{this.props.showAdBlock}
				</div>
			);
			if (arrayOfTariffs.length > insertAdBlock) {
				arrayOfTariffs.splice(insertAdBlock, 0, adblock);
			} else {
				arrayOfTariffs.push(adblock);
			}
		}

		return arrayOfTariffs;
	}

	_renderPlanAdd(mobile) {
		let classes = this.props.classes;
		if (!!this.props.useCarousel && this.props.windowSizes.xs) {
			return null;
		}

		return (
			<Col
				xs="12"
				lg="2"
				className={classNames(classes.item, classes.ad)}
				onClick={this.props.onClickPlanAddButton}
			>
				{this.props.planAdd}
			</Col>
		);
	}

	_renderViewAllButton() {
		if (!this.props.showViewAllButton) {
			return null;
		}
		let classes = this.props.classes;
		let text = this.props.ApplicationModel.text;
		return (
			<div className={classes.buttonWrapper} onClick={this.props.onClickViewAll}>
				<div className={classes.button}>
					<Button
						typeText="big"
						size={"middle"}
						transparent={true}
						fullWidth={true}
						component={this.props.link}
						status={"tertiaryAccent"}
					>
						{text.tariffsShowMore}
					</Button>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(PlansList);
